
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                :state="errors.length > 0 ? false:null"
                placeholder="Nom"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                :state="errors.length > 0 ? false:null"
                placeholder="Prix"
              />
               <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Icone"
              label-for="Icone"
            >
            <b-media vertical-align="top" v-if="file2!==null">
                  <template #aside>
                    <b-img
                      :src="file2"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editIcon()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file2"
                :state="Boolean(file2)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded2($event)"
            />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Photo"
              label-for="Photo"
            >
            <b-media vertical-align="top" v-if="file!==null">
                  <template #aside>
                    <b-img
                      :src="file"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editPhoto()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded($event)"
            />
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <label for="textarea-default">Description</label>
            <b-form-textarea
              v-model="form.description"
              id="textarea-default"
              placeholder="Description"
            
              rows="3"
            />
            </b-col>
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>

  <b-button v-if="edition==false"
     @click="createGlassType"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="updateGlassType"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput,BMedia, BCardText, BImg, BForm, BRow,BOverlay, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest} from '@simb2s/senseye-sdk'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
export default {
  name: 'GlassTypeForm',
  components: {
    BButton,
    BFormInput,
    BImg,
    BCardText,
    BMedia,
    BFormGroup,
    BRow,
    BCol,
    BOverlay,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  data() {
      return {
          currentBase64:null,
          currentBase642:null,
          edition:false,
          loading:true,
          file:null,
          file2:null,
          form:{
            name:"",
            price:0,
            photo:null, 
            icon:null,
            description:'',
          },
      }
  },
  props: ['glass_type', 'readOnly'],
  methods:{
    editPhoto() {
      this.file=null
    },
    editIcon() {
      this.file2=null
    },
    fileAdded2(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
         
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase642=reader.result
              this.form.icon=this.currentBase642
          }
          else
          {
              this.file2=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
         
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.form.photo=this.currentBase64
          }
          else
          {
              this.file=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Ceci n'est pas une image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
    async createGlassType()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
          
          await APIRequest.create('glass-types',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Le type de verre a bien été créé !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'glass-types'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
    async updateGlassType()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
      this.loading=true
        try {
          
          await APIRequest.update('glass-types',this.glass_type.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Le type de verre a bien été modifié !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'glass-types'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
   

  },
  async mounted(){
    if(this.glass_type!=null)
    {
      this.form=this.glass_type
      if(this.glass_type.photo!="")
      {
        this.file=this.glass_type.photo
      }
      if(this.glass_type.icon!="")
      {
        this.file2=this.glass_type.icon
      }
      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>